import React, { useContext, useEffect, useState } from 'react';

import moment from 'moment';

import { GlobalContext } from '../../../../../store';
import { IEventItem } from '../../../../../store/player/events/store';

import EventContent from '../../../../../components/NextEvent/Components/EventContent/EventContent';
import { sortBy } from '../../../../../contrib/sortBy';
import { UpcomingEventsStyled } from './UpcomingEvents.Styles';
import { today } from '../../../../../Utils/today';
import NextEvent from '../../../../../components/NextEvent/NextEvent';

const UpcomingEvents = () => {
  const { events } = useContext(GlobalContext);

  const [upcomingEvents, setUpcomingEvents] = useState<IEventItem[]>([]);

  const allEvents: IEventItem[] = sortBy(Object.values(events.all), 'asc', 'start');

  const nextActiveEvent = allEvents.find(
    ({ start, enrollment: { status } }) => moment(start).isAfter(today) && status === 'active'
  );

  useEffect(() => {
    const newAllEvents = allEvents.filter(
      ({ start, enrollment: { status } }) =>
        moment(start).isAfter(today) && (status === 'invited' || status === 'active')
    );

    const sortedNewAllEvents = sortBy(newAllEvents, 'asc', 'start');

    setUpcomingEvents(sortedNewAllEvents);
  }, [allEvents]);

  return upcomingEvents.length > 0 ? (
    <UpcomingEventsStyled>
      <h3>UPCOMING EVENTS</h3>

      <NextEvent item={nextActiveEvent} />

      <div className="events-container">
        {upcomingEvents.map(event => (
          <EventContent item={event} key={event.id} />
        ))}
      </div>
    </UpcomingEventsStyled>
  ) : (
    <></>
  );
};

export default UpcomingEvents;
